import { useState, useEffect } from 'react'

const useDataPage = (dataAll: any[] | null, pageSizeDefault: number = 5, pageDefault: number = 1) => {
  const [data, setData] = useState<any[] | null>(null)
  const [pageCurrent, setDataPageCurrent] = useState<number>(pageDefault)

  useEffect(() => {
    getDataPageCurrent(pageDefault)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAll])

  const getDataPageCurrent = (pageCurrent: number) => {
    const rowEnd: number = (pageCurrent * pageSizeDefault) - 1
    const rowIni: number = (rowEnd - pageSizeDefault) + 1

    setData(
      dataAll && dataAll.length ?
        dataAll.filter((it: any, i: number) => {
          return i >= rowIni  && i <= rowEnd
        })
      :
        dataAll
    )
  }

  const setPageCurrent = (pageCurrent: number = pageDefault) => {
    setDataPageCurrent(pageCurrent)
  }

  const onPageCurrent = (pageCurrent: number) => {
    setPageCurrent(pageCurrent)
    getDataPageCurrent(pageCurrent)
  }

  return {
    data,
    pageCurrent,
    setPageCurrent,
    onPageCurrent
  }
}

export { useDataPage }